module.exports = __webpack_public_path__ + "img/Frame 26.d1a11549.png";